import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, captcha_id, captcha_answer) => {
    const { data } = await api.post("/auth/login", { email, password, captcha_id, captcha_answer });
    if (data.two_factor) return data;
    setUser(data);
    return data;
  };

  const register = async (name, email, password, captcha_id, captcha_answer) => {
    const { data } = await api.post("/auth/register", { name, email, password, captcha_id, captcha_answer, ref: localStorage.getItem("cs_ref") || undefined });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { formatApiErrorDetail };
